import Employees from './Employees'

export default Employees
